// extracted by mini-css-extract-plugin
export default {"container":"TX-z","title":"UX-z","link":"VX-z"};